import React from 'react'
import PropTypes from 'prop-types'
import ImageFallback from 'Components/imagefallback/next_image'

const MaleDailyArticleCardOne = ({ isMobile, image, title, url, category }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <a className="article-style-one" href={url}>
        <div
          className={`article-style-one__image article-style-one__image--${device}`}
        >
          <ImageFallback
            objectFit="cover"
            alt={title}
            src={image || process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_SQUARE}
            fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
            width={500}
            height={500}
            quality={100}
          />
        </div>
        <div className="article-style-one__text">
          <div className="article-style-one__category fd-body-sm-regular">
            {category?.replace(/_/gi, ' ')}
          </div>
          <div
            className={[
              'article-style-one__title',
              isMobile ? 'fd-heading-3' : 'fd-heading-2',
            ].join(' ')}
          >
            {title}
          </div>
        </div>
      </a>
      <style jsx>
        {`
          .article-style-one {
            display: flex;
            flex-direction: column;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-one__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-one__image {
            height: 100%
            max-height: 400px;
            aspect-ratio: 1/1;
          }

          .article-style-one__image--mobile {
            max-height: 328px;
          }

          .article-style-one__category {
            color: var(--text-sub);
            text-transform: capitalize;
          }

          .article-style-one__title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .article-style-one__title:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardOne.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  category: PropTypes.string,
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardOne
